var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhsUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_861_87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66675C5.39167 1.66675 1.66667 5.39175 1.66667 10.0001C1.66667 14.6084 5.39167 18.3334 10 18.3334C14.6083 18.3334 18.3333 14.6084 18.3333 10.0001C18.3333 5.39175 14.6083 1.66675 10 1.66675ZM10 16.6667C6.32501 16.6667 3.33334 13.6751 3.33334 10.0001C3.33334 6.32508 6.32501 3.33341 10 3.33341C13.675 3.33341 16.6667 6.32508 16.6667 10.0001C16.6667 13.6751 13.675 16.6667 10 16.6667ZM12.9917 5.83341L10 8.82508L7.00834 5.83341L5.83334 7.00841L8.82501 10.0001L5.83334 12.9917L7.00834 14.1667L10 11.1751L12.9917 14.1667L14.1667 12.9917L11.175 10.0001L14.1667 7.00841L12.9917 5.83341Z",
    fill: "#ED4A4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_861_87"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhsUnchecked);
export default __webpack_public_path__ + "static/media/WHSUnchecked.e41caf42f8b5678a5a1f9cbea97631ab.svg";
export { ForwardRef as ReactComponent };